import {ClientPhoneNumber} from "./ClientPhoneNumber";

export type ClientPhonePredicate = (phone: ClientPhoneNumber) => boolean;

export const matchingClientPhoneNumber =
  (number?: string): ClientPhonePredicate =>
  (phone: ClientPhoneNumber): boolean =>
    phone.number === number;
